<template>
  <div>
    <carousel v-model="carouselIndex" :wrap-around="true" :autoplay="3000">
      <slide :key="1">
        <article class="rounded h-[572px] object-cover">
          <div class="test">
            <img
              :src="HomeBg"
              alt="home-header-img"
              class="main-img object-cover"
              style="z-index: -1"
            />
          </div>
          <div class="header-body">
            <div>
              <h1 class="text-left <tablet:text-h4 <tablet:leading-h4">
                從顧客管理創造永續營收，<br class="<tablet:hidden" />
                用Social CRM 打造0距離的顧客體驗
              </h1>
              <div class="pt-[28px]">
                <button
                  class="primary-btn flex"
                  @click.prevent="scrollPageTo('form')"
                >
                  <span>聯絡我們</span>
                </button>
              </div>
            </div>
          </div>
        </article>
      </slide>

      <!-- <slide :key="2">
        <a href="https://tcloud.digitspark.co/" class="w-full" target="_blank">
          <img class="ob-lg w-full" :src="obLG" alt="" />
          <img class="ob-md w-full" :src="obMD" alt="" />
          <img class="ob-sm w-full" :src="obSM" alt="" />
        </a>
      </slide> -->

      <template #addons>
        <Pagination class="opacity-0" />
      </template>
    </carousel>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from 'vue'
import { scrollPageTo } from '@/utils/helper'
import { useRoute } from 'vue-router'
import { Carousel, Slide, Pagination } from 'vue3-carousel'

import obSM from '@/assets/header/OB-sm.png'
import obMD from '@/assets/header/OB-md.png'
import obLG from '@/assets/header/OB-large.png'
import HomeBg from '@/assets/header/Home.jpg'

const route = useRoute()
const page = computed(() => route.name)

const carouselIndex = ref(0)
</script>

<style lang="postcss" scoped>
.header-body {
  @apply text-white flex flex-col justify-start z-5 absolute top-0 left-0 right-0 bottom-0;
  @apply flex justify-center items-center;
  @apply mx-[30px] pt-[160px] pb-[300px];
  @apply <tablet:pt-[80px] pb-[160px];
}

#home {
  @apply text-left;
  @apply mx-[30px] pt-[160px] pb-[300px];
  @apply <tablet:pt-[80px] pb-[160px];
  @apply flex flex-col justify-center items-center;
}

button {
  padding: 15px 68px;
  @apply text-[18px];
}

.test {
  @apply absolute top-0 left-0 right-0 bottom-0 object-cover;
}

.main-img {
  @apply w-full h-full;
  @apply rounded-bl-[200px] <desktop:rounded-bl-[120px] <laptop:rounded-bl-[60px];
}

@media screen and (min-width: 1050px) {
  .ob-lg {
    @apply block;
  }
  .ob-md {
    @apply hidden;
  }
  .ob-sm {
    @apply hidden;
  }
}

@media screen and (min-width: 1050px) {
  .ob-lg {
    @apply block;
  }
  .ob-md {
    @apply hidden;
  }
  .ob-sm {
    @apply hidden;
  }
}

@media screen and (max-width: 1050px) {
  .ob-lg {
    @apply hidden;
  }
  .ob-md {
    @apply block;
  }
  .ob-sm {
    @apply hidden;
  }
}

@media screen and (max-width: 500px) {
  .ob-lg {
    @apply hidden;
  }
  .ob-md {
    @apply hidden;
  }
  .ob-sm {
    @apply block;
  }
}
</style>
